import { render, staticRenderFns } from "./TransferView.vue?vue&type=template&id=5afc12b2"
import script from "./TransferView.vue?vue&type=script&lang=js"
export * from "./TransferView.vue?vue&type=script&lang=js"
import style0 from "./TransferView.vue?vue&type=style&index=0&id=5afc12b2&prod&lang=scss"
import style1 from "./TransferView.vue?vue&type=style&index=1&id=5afc12b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports